<template>
  <div @click.stop class="fixed bottom-[10px] right-[10px] z-40">
    <div
      class="relative flex cursor-pointer flex-col items-start justify-start gap-0.5 self-stretch"
      @trigger="hideOnClickOutside"
    >
      <a
        class="group absolute bottom-[110%] right-0 mt-[37px] inline-flex w-full min-w-max flex-col items-start justify-start gap-4 rounded-bl-xl rounded-tl-xl rounded-tr-xl bg-[#22c55e] px-4 py-6 duration-300"
        :class="{ '!hidden': !isVisible }"
        :href="whatsAppLink"
        target="_blank"
        rel="nofollow noopener noreferrer"
        @click="closeWidget"
      >
        <img :src="whatsappLogo" alt="" width="124" height="29" />
        <div class="flex flex-col items-start justify-start gap-0.5 self-stretch">
          <p class="text-lg font-bold leading-[27px] text-white">Get a quick consultation</p>
          <p class="text-sm font-normal leading-[21px] text-white">
            Our managers respond instantly.
          </p>
        </div>
        <div
          class="flex w-full shrink grow basis-0 items-center justify-center gap-2 rounded-lg border border-transparent bg-black px-[31px] py-[13px] duration-300 group-hover:border-white group-hover:bg-transparent"
        >
          <span class="text-center text-sm font-bold leading-tight text-white duration-300"
            >Write to WhatsApp</span
          >
        </div>
      </a>
      <WhatsAppIcon @click="toggleVisibility" />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import whatsappLogo from '~project_assets/images/whatsapp-logo.png'
import WhatsAppIcon from '@/components/ui/icons/WhatsAppIcon.vue'

const whatsAppLink = ref('https://wa.me/+')

switch (import.meta.env.VITE_PROJECT_ALIAS) {
  case 'dli':
    whatsAppLink.value += '390553950449'
    break
  case 'rlt':
    whatsAppLink.value += '390553950489'
    break
  case 'dgt':
    whatsAppLink.value += '390553950429'
    break
}

const isMobile = ref(false)

isMobile.value = window?.innerWidth <= 767

const isVisible = ref(false)

const hideOnClickOutside = () => {
  isVisible.value = false
}
const closeWidget = () => {
  isVisible.value = false
}

const toggleVisibility = () => {
  isVisible.value = !isVisible.value
}

onMounted(() => {
  document.addEventListener('click', closeWidget)
})
</script>
